import React from 'react';
import { Paper, Tooltip } from '@material-ui/core';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']; // WEEKDAY(): 0=Mon
const HOUR_LABELS = [0, 3, 6, 9, 12, 15, 18, 21];

// Weekday × hour heatmap of scan volume — answers "when does foot traffic
// scan?" (staffing / showroom-hours signal). Built from rows of {dow,hour,scans}.
const ActivityHeatmap = ({ heatmap }) => {
  const grid = Array.from({ length: 7 }, () => Array(24).fill(0));
  let max = 0;
  (heatmap || []).forEach(({ dow, hour, scans }) => {
    if (dow >= 0 && dow < 7 && hour >= 0 && hour < 24) {
      grid[dow][hour] = scans;
      if (scans > max) max = scans;
    }
  });

  const cellColor = (v) => {
    if (!v) return undefined;
    const alpha = 0.15 + 0.85 * (v / max);
    return `rgba(40, 196, 252, ${alpha})`;
  };

  return (
    <Paper className="insights__card insights__col-4" variant="outlined">
      <div className="insights__card-head">
        <span className="insights__card-title">Activity by Hour</span>
        <span className="insights__card-sub">day × hour</span>
      </div>
      {max === 0 ? (
        <div className="insights__empty">No scans in this period.</div>
      ) : (
        <div className="insights__heatmap">
          {/* top-left corner spacer */}
          <div className="insights__heat-collabel" />
          {Array.from({ length: 24 }, (_, h) => (
            <div key={`h${h}`} className="insights__heat-collabel">
              {HOUR_LABELS.includes(h) ? h : ''}
            </div>
          ))}
          {DAYS.map((day, d) => (
            <React.Fragment key={day}>
              <div className="insights__heat-rowlabel">{day}</div>
              {grid[d].map((v, h) => (
                <Tooltip
                  key={`${d}-${h}`}
                  title={`${day} ${h}:00 — ${v} scan${v === 1 ? '' : 's'}`}
                >
                  <div
                    className="insights__heat-cell"
                    style={{ background: cellColor(v) }}
                  />
                </Tooltip>
              ))}
            </React.Fragment>
          ))}
        </div>
      )}
    </Paper>
  );
};

export default ActivityHeatmap;
